import { ContactOption } from "./scenario.types";

export type DeviceLocation = {
  name: string;
  lat?: number;
  lng?: number;
  locationId?: string;
};

export enum DeviceTypeCategory {
  DESKTOP_CLIENT = "DESKTOP_CLIENT",
  HARDWARE_DEVICE = "HARDWARE_DEVICE",
}

export enum DeviceTypeCategoryGerman {
  HARDWARE_DEVICE = "Hardware Button",
  DESKTOP_CLIENT = "Desktop Instanz",
}

export type CommonDevice = {
  id: string;
  name: string;
  userId: string;
  testWithFax: boolean; // internal real fax api testing mode
  contactSettings?: Map<ContactOption, string[]>;
  deviceTestMode?: boolean; // UserBO Device Testing Mode
  scenarioIds?: string[];
  exactPosition?: string;
};

export type DesktopClient = CommonDevice & {
  typeCategory: DeviceTypeCategory.DESKTOP_CLIENT;
  email: string;
};

export type DeviceType = CommonDevice & {
  typeCategory: DeviceTypeCategory.HARDWARE_DEVICE;
  serialNumber: string;
  deviceId: string;
  location: DeviceLocation;
};

export type FSDevice = Omit<DeviceType, "contactSettings"> & {
  contactSettings?: Record<ContactOption, string[]>;
};

export type FSDesktopClient = Omit<DesktopClient, "contactSettings"> & {
  contactSettings?: Record<ContactOption, string[]>;
};

export interface DeviceBatteryType {
  value: number;
  date: moment.Moment;
}

export const isHardwareDevice = (
  device: DeviceType | DesktopClient
): device is DeviceType => {
  return device.typeCategory === DeviceTypeCategory.HARDWARE_DEVICE;
};

export const isDesktopClient = (
  device: DeviceType | DesktopClient
): device is DesktopClient => {
  return device.typeCategory === DeviceTypeCategory.DESKTOP_CLIENT;
};
